import Vue from "vue"

import "./plugins/axios"
import "./plugins/date-fns"
import vuetify from "./plugins/vuetify"
import "./plugins/gettext"
import "./plugins/json-csv"
import "./directives/if-superuser"
import "./mixins/global"
import "./customComponents"

import App from "./App.vue"
import router from "./router"
import store from "./store"

import "@/assets/variables.scss"
import "@fortawesome/fontawesome-free/css/all.css"

Vue.config.productionTip = false

store.dispatch("getUser")

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")
